export const selectAgencyState = (state) => state.agency

export const selectSelectedAgency = (state) => state.agency?.selectedAgency
